import { gql } from '@apollo/client';

export const SET_READINESS_GAUGE_INSTANCE_MUTATOR = gql`
  mutation setReadinessGaugeInstanceMutation(
    $group_id: String!
    $readiness_gauge_instance: JSON!
    $user_email: String!
    $original_readiness_gauge_instance: JSON
  ) {
    setReadinessGaugeInstance(
      group_id: $group_id
      readiness_gauge_instance: $readiness_gauge_instance
      user_email: $user_email
      original_readiness_gauge_instance: $original_readiness_gauge_instance
    )
  }
`;

export const DELETE_READINESS_GAUGE_INSTANCE = gql`
  mutation DeleteReadinessGaugeInstanceMutation(
    $readiness_gauge_instance_id: String!
    $readiness_gauge_instance_name: String!
    $group_id: String!
    $user_email: String!
  ) {
    deleteReadinessGaugeInstance(
      readiness_gauge_instance_id: $readiness_gauge_instance_id
      readiness_gauge_instance_name: $readiness_gauge_instance_name
      group_id: $group_id
      user_email: $user_email
    )
  }
`;
